import React from 'react';
import classnames from 'classnames';
import { Tabs } from 'tea-component';
import NewMarkIcon from '@home/components/NewMarkIcon';
import { isEmpty } from '@gp/utils/common';

import type { TabsProps, Tab } from 'tea-component';
import type { IRecord, INewMarkCfg } from '@gp/types/global';

interface INewIconTab extends Tab, INewMarkCfg {}

const formatNewMarkTabs = (tabs?: Tab[] | null, newMarkCfgMapping?: IRecord<INewMarkCfg> | null): INewIconTab[] => {
  if (!Array.isArray(tabs) || !tabs.length) return [];
  return tabs.map((tab) => {
    const { id, label: label } = tab || {};
    const { showNew, newMarkType } = newMarkCfgMapping?.[id] || {};
    const defaultNewMarkType = newMarkType || 0;
    const labelTmp =
      !showNew || isEmpty(defaultNewMarkType) ? (
        label
      ) : (
        <div className="dbg-flex-center">
          {label}
          <NewMarkIcon type={defaultNewMarkType} />
        </div>
      );
    return {
      ...tab,
      showNew: showNew || false,
      newMarkType: defaultNewMarkType || 0,
      label: labelTmp,
    };
  });
};

interface INewIconTabsProps extends TabsProps {
  newMarkCfgMapping?: IRecord<INewMarkCfg> | null;
}

const NewIconTabs: React.FC<INewIconTabsProps> = (props) => {
  const { className, tabs: tabsProps, newMarkCfgMapping, ...restProps } = props;

  const tabs = formatNewMarkTabs(tabsProps, newMarkCfgMapping);

  return (
    <Tabs {...restProps} className={classnames('dbh-new-icon-tabs dbi-detail-new-icon-tabs', className)} tabs={tabs} />
  );
};

export default NewIconTabs;
